import jsCookie from 'js-cookie';
import { authUrl, authCookieDomain } from '@/utils/env';
import jsBridgeApi from '@/utils/jsBirdge';
import { isNative } from '@/utils/platform';
import { logError, logInfo } from '@/utils/logger/arms-config';
import { resetUserInfo } from '@/utils/logger/bd-tracker';
import store from '@/stores';

const isTourist = ()=> store.getState().user.userPermission.isTourist;

/**
 * web 登录
 * !important 业务中尽量直接使用login
 */
function loginWeb() {
  const org = jsCookie.get('org');
  const p = org ? 'org' : '';
  const s = org ? `org=${org}&` : '';
  const loginUrl = `${authUrl}${p}?${s}redirect_uri=${btoa(window.location.href)}`;
  // window.location.replace(loginUrl);
  window.location.href = loginUrl;
}

/**
 * native 登录
 * !important 业务中尽量直接使用login
 */
function loginNative() {
  jsBridgeApi.openPage('/login');
}

// 登录(强制登录)
export function login() {
  console.log('[强制登录] cookie', document.cookie);
  logInfo({ type: 'login', token: !!jsCookie.get('token'), position: 'user_login' });
  if (!isTourist()){
    jsCookie.remove('token');
    jsCookie.remove('token', {
      domain: authCookieDomain,
    });
    resetUserInfo();
  }
  if (!isNative()) {
    setTimeout(() => {
      loginWeb();
    }, 200);
  } else {
    loginNative();
  }
}

// 登出
export function logout() {
  jsCookie.remove('token', {
    domain: authCookieDomain,
  });
  jsCookie.remove('token');
  resetUserInfo();
  if (!isNative()) {
    // 如果有 org 表示上一次登录使用了机构账号，强制跳转到机构登录页；否则走正常游客逻辑
    if (jsCookie.get('org')) {
      login();
    } else {
      window.location.href = '/';
    }
  } else {
    jsBridgeApi.close();
  }
}

// 检查是否有token，如果有，返回true，否则强制登录
// 游客token视同有临时用户，在此流程中不强制登录
export function checkHasToken(): boolean {
  const token = jsCookie.get('token');
  if (!token) {
    logError(new Error('接口需要token'));
    login();
    return false;
  } else {
    return true;
  }

}

// 清理登录状态
export function clearLoginState() {
  jsCookie.remove('token', {
    domain: authCookieDomain,
  });
  jsCookie.remove('token');
}
